export default "__VITE_ASSET__CmQssL_Q__"